// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CasePhoneContactInformationType;
(function (CasePhoneContactInformationType) {
    CasePhoneContactInformationType[CasePhoneContactInformationType["UNKNOWN"] = 1] = "UNKNOWN";
    CasePhoneContactInformationType[CasePhoneContactInformationType["PHONE"] = 2] = "PHONE";
    CasePhoneContactInformationType[CasePhoneContactInformationType["MOBILE"] = 3] = "MOBILE";
})(CasePhoneContactInformationType || (CasePhoneContactInformationType = {}));
//# sourceMappingURL=casePhoneContactInformationType.js.map